import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQuery } from './api';
import { endpoints } from './endpoints';

export interface ImageManifestForRbl {
  imageManifestId: number;
  pipelineVideaErrorCode: string | null;
  pipelineExceptionName: string | null;
  pipelineExceptionMessage: string | null;
  pipelineStartTime: Date | null;
  pipelineCompletionReason: string | null;
  s3Path: any | null;
}

interface UsePatientRblParams {
  imageManifestIdsToSkip: number[];
  estimatedVisitId: number;
  videaPatientId: string | undefined;
  shouldMakeApiRequest: boolean;
}

export type GetRblPatientDataResponse = {
  imageManifestsForRbl: ImageManifestForRbl[];
};

export const usePatientRblData = ({
  imageManifestIdsToSkip,
  estimatedVisitId,
  videaPatientId,
  shouldMakeApiRequest,
}: UsePatientRblParams) => {
  const { primaryPracticeId: currentPracticeId } = useSelector(
    (state: any) => state.login.user,
  );

  const path = `${endpoints.patient}/get-rbl-patient-data`;
  return useQuery<GetRblPatientDataResponse>(
    [path, estimatedVisitId, imageManifestIdsToSkip],
    () =>
      makeAPIRequestReactQuery<GetRblPatientDataResponse>(
        path,
        {
          estimatedVisitId: estimatedVisitId,
          videaPatientId: videaPatientId,
          practiceId: currentPracticeId,
          imageManifestIdsToSkip: imageManifestIdsToSkip,
        },
        'GET',
      ),
    {
      enabled: shouldMakeApiRequest,
    },
  );
};
